<template>
  <header class="sub race-filters">
    <slot name="pre"></slot>
    <button v-for="race in displayedRaces" 
      :key="race.id"
      :class="{light: false, selected: filteredRaceIds[race.id]}" 
      :title="`Race ID ${race.id}`" 
      :style="`--race-color: ${race.color}`" 
      @click="filterToRace(race, $event)"
    >
      {{ race.name }}
    </button>
    
    <button :class="{all: true, light: false, selected: allSelected}" @click="filterToRace(null, $event)">
      All
    </button>
    
    <span class="flexible-space" />
    
    <slot></slot>
    
  </header>
</template>

<style lang="scss">
.race-filters {
  &.restrict {
    max-width: 600px;
    overflow-x: scroll;

    -ms-overflow-style: none;  /* Internet Explorer 10+ */
    scrollbar-width: none;  /* Firefox */

    &::-webkit-scrollbar { 
        display: none;  /* Safari and Chrome */
    }
  }
}
</style>


<script>

import RaceFiltersMixin from '@/lib/mixins/race-filters'

export default {
  name: 'RaceFilters',
  mixins: [RaceFiltersMixin],
  props: {
    raceEvent: {
      type: Object,
      required: true
    },
    showIndependent: {
      type: Boolean,
      default: () => false,
    }
  },
  
  computed: {
    displayedRaces() {
      const r = this.racesByTime;
      if (!this.showIndependent) {
        return r.filter(a => a.name !== 'Independent Add-on Order')
      }
      return r;
    },
    
    allSelected() {
      const races = this.filteredRaces;
      return Object.keys(races)
        .filter(r=>races[r])
        .length < 1
    }
  }
}

</script>

